export enum TemplatePaymentType {
	DOMESTIC = 'DOMESTIC',
	INTERNAL = 'INTERNAL',
	INTERNATIONAL = 'INTERNATIONAL',
}

export enum TemplateType {
	JOINT = 'JOINT',
	INDIVIDUAL = 'INDIVIDUAL',
}

export interface PaymentTemplate {
	uuid: string;
	name: string;
	creator_id: number | string;
	customer_id: number | string;
	payment_type: TemplatePaymentType;
	template_type: TemplateType;
	transaction_type: string;
	amount: number;
	currency: string;
	payment_details: string;
	beneficiary: TemplateBeneficiary;
	ultimate_beneficiary: TemplateUltimateBeneficiary;
	payer: TemplatePayer;
	intermediary_bank: any;
	correspondent_bank: any;
	direction: string;
	created_at: string;
	updated_at: string;
	account_uuid?: string;
}

export interface CreatePaymentTemplate {
	name: string;
	customer_id?: number | string;
	payment_type: TemplatePaymentType;
	template_type: TemplateType;
	amount?: number;
	currency?: string;
	payment_details?: string;
	payment_urgency?: 'NORMAL' | 'FAST' | 'URGENT';
	beneficiary?: TemplateBeneficiary;
	ultimate_beneficiary?: TemplateUltimateBeneficiary;
	payer?: IdType;
	primary_payer?: TemplatePayer;
	correspondent?: CorrespondentBank;
	direction?: string;
	account_uuid?: string;
}

export interface CorrespondentBank {
	name?: string;
	bic?: string;
	address?: TemplateAddress;
}

export interface TemplateBeneficiary {
	id?: IdType;
	name?: string;
	account?: string;
	address?: TemplateAddress;
	bank?: TemplateBankInformation;
}

interface TemplateBankInformation {
	name?: string;
	bic?: string;
	address?: TemplateAddress;
}

export interface TemplateUltimateBeneficiary {
	id?: IdType;
	name?: string;
	account?: string;
	address?: TemplateAddress;
}

// ToDo: unify TemplateAddress with BE (when BE will clean up this mess)
export interface TemplateAddress {
	country?: string;
	postal_code?: string;
	town?: string;
	building_number?: string;
	line?: string;
	type?: 'UNSTRUCTURED' | 'STRUCTURED';
}

export interface IdType {
	type?: string;
	value?: string;
}

export interface TemplatePayer {
	id?: IdType;
	name?: string;
	accountId?: string;
	bic?: string;
	iban?: string;
}

export interface TemplateItemResponse {
	uuid: string;
	name: string;
	payment_type: TemplatePaymentType;
	template_type: TemplateType;
	account_uuid?: string;
	amount?: number;
	currency?: string;
	iban?: string;
	beneficiary?: BeneficiaryShort;
	updated_at?: string;
}

export interface BeneficiaryShort {
	name?: string;
	account?: string;
}
